export default class VueRoute {
	constructor(name, parameters = {}, query = {}) {
		this.name = name;
		this.parameters = parameters;
		this.query = query;
		return this;
	}

	parameters(parameters = {}) {
		this.parameters = parameters;
		return this;
	}

	query(query = {}) {
		this.query = query;
		return this;
	}

	addQuery(key, value) {
		_.set(this.query, key, value);
		return this;
	}

	create() {
		return {
			name: this.name,
			params: this.parameters,
			query: _.mapValues(this.query, value => {
				return Qs.stringify(
					value,
					{
						arrayFormat: "brackets",
					}
				);
			}),
		};
	}
}
